export const socketEventsHandlerDelays = {
  handleBetsClosed: 500,
  handleRoundStart: 200,
  handleDoBetResult: 500,
  handleResultReport: 1500,
  handleRoundFin: 700,
};
